module.exports = __webpack_public_path__ + "img/afterlife_logo_main.3ced25e3.svg";